import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import AccessibleCard from "../../components/cards/AccessibleCard";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

// Example image imports (replace with your actual assets)
import mobileapp1 from "../../assets/mobileApp/mobileapp1.png";
import mobileapp2 from "../../assets/mobileApp/mobileapp2.png";
import mobileapp3 from "../../assets/mobileApp/mobileapp3.png";

import mobile1es from "../../assets/spanish/MobileApp/mobile1es.png";
import mobile2es from "../../assets/spanish/MobileApp/mobile2es.png";
import mobile3es from "../../assets/spanish/MobileApp/mobile3es.png";

const MobileAppCardsSection= () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t, i18n } = useTranslation();
  const card1 = i18n.language === "es" ? mobile3es: mobileapp1;
const card2 = i18n.language === "es" ?mobile1es : mobileapp2;
const card3 = i18n.language === "es" ?mobile2es : mobileapp3;
 const cards = [

  {
icon: (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
    <img
      // src={mobileapp2}
          src={card2}
      alt="Icon 2"
      style={{ width: "60%", height: "auto", objectFit: "contain" }}
    />
  </Box>
),
    title: t("mobile_cards.executive.title"),
    description: t("mobile_cards.executive.description")
  },
  {
   icon: (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
    <img
      // src={mobileapp3}
       src={card3}
      alt="Icon 2"
      style={{ width: "60%", height: "auto", objectFit: "contain" }}
    />
  </Box>
),
    title: t("mobile_cards.admin.title"),
    description: t("mobile_cards.admin.description")
  },
    {
icon: (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
    <img
      // src={mobileapp1}
        src={card1}
      alt="Icon 2"
      style={{ width: "60%", height: "auto", objectFit: "contain" }}
    />
  </Box>
),
    title: t("mobile_cards.worker.title"),
    description: t("mobile_cards.worker.description")
  },
];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        gap: 3,
        justifyContent: "space-between",
        px: isMobile ? 2 : 15,
        py: 4,
        mt:5,
        mb:5,
      }}
    >
      {cards.map((card, index) => (
        <Box key={index} sx={{ flex: "1 1 30%",}}>
          <AccessibleCard
            icon={card.icon}
            title={
    <Box sx={{ fontSize: "18px", fontWeight: 600, lineHeight: "1.2" }}>
      {card.title}
    </Box>
  }
            description={card.description}
            descriptionStyle={{ lineHeight: "140%" }}
            variant="light"
              sx={{
    borderTop: "1px solid  #DFDFDF",
    borderTopLeftRadius: "4px",
  borderTopRightRadius: "4px",

    pt:2, // ✅ This will override the default 'none'
  }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default MobileAppCardsSection;
